export class HubEvents {
	static incomingMeasurementEvent: string = "incomingMeasurementEvent";
	static incomingDataEvent: string = "incomingDataEvent";
	static measurementEvent: string = "measurementEvent";
	static gpsMappingEvent: string = "gpsMappingEvent";
	static assetLocationMeasurementEvent = "assetLocationMeasurementEvent"
	static networkChange: string = "networkChange";
	static refresh: string = "refresh";
	static signalRDisconnect: string = "signalRDisconnect";
}